import React from 'react';
import styles from './Courses.module.css';
import p1 from './imgs/pic1.jpeg';
import p2 from './imgs/pic2.jpeg';
import p3 from './imgs/pic3.jpeg';

const courses = [
  {
    title: 'Crochet',
    img: p1,
    desc: 'Start your crochet journey! Learn basic stitches, patterns, and create your first project in a cozy group setting.',
    link: '#',
  },
  {
    title: 'Intermediate Knitting',
    img: p2,
    desc: 'Expand your skills with advanced stitches, colorwork, and garment making. Perfect for those who know the basics.',
    link: '#',
  },
  {
    title: 'Macramé & Yarn Art',
    img: p3,
    desc: 'Explore the art of macramé and creative yarn crafts. Includes wall hangings, plant holders, and more.',
    link: '#',
  },
  {
    title: 'Custom Workshops',
    img: p1,
    desc: 'Book a private or group workshop tailored to your interests—great for birthdays, events, or team building!',
    link: '#',
  },
];

function Courses() {
  return (
    <div className={styles.coursesContainer}>
      <div className={styles.coursesTitle}>Our Courses</div>
      <div className={styles.coursesSubtitle}>
        Whether you are a beginner or an experienced crafter, we have a course for you! Join our warm, creative community and learn at your own pace.
      </div>
      <div className={styles.coursesGrid}>
        {courses.map((course, idx) => (
          <div className={styles.courseCard} key={idx}>
            <img src={course.img} alt={course.title} className={styles.courseImg} />
            <div className={styles.courseInfo}>
              <div className={styles.courseTitle}>{course.title}</div>
              <div className={styles.courseDesc}>{course.desc}</div>
              <a href={course.link} className={styles.courseBtn} target="_blank" rel="noopener noreferrer">Learn More</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Courses;
